module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/body_part_icon-d8fa89e4384d955a631489370517f9f4.png";